<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <div class="table-agile-info">
          <jm-crumbs/>
          <el-form
            :inline="true"
            :model="searchData">
            <el-form-item label="角色ID">
              <el-input v-model="searchData['roleid']"/>
            </el-form-item>
            <el-form-item label="角色名称">
              <el-input v-model="searchData['rolename']"/>
            </el-form-item>
            <el-form-item label="所属国家">
              <jm-dict-select
                class="jm-input220"
                clearable
                filterable
                dict-type="country"
                v-model="searchData['country']"/>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                @click="() => this.refresh = true">查询</el-button>
            </el-form-item>
          </el-form>
          <jm-tableList
            url="/index/Power/group"
            no-pagination
            :refresh.sync="refresh"
            :search-data="searchData">
            <el-table-column
              slot="lastColumn"
              label="操作"
              width="140">
              <template slot-scope="scope">
                <el-button
                  size="small"
                  type="primary"
                  @click="handleEditRules(scope)">编辑权限</el-button>
              </template>
            </el-table-column>
          </jm-tableList>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs.vue';
import toolbar from '@/components/tool/toolbar.vue';
import tableList from '@/components/data/tableList.vue';
import { jmDictSelect } from '@/components/tool/index.js';

export default {
  data() {
    return {
      refresh: false,
      searchData: {}
    };
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-toolbar': toolbar,
    'jm-tableList': tableList,
    jmDictSelect
  },
  computed: {

  },
  methods: {
    fetchMenu() {
      this.refresh = true;
    },
    handleEditRules(scope) {
      this.$router.push({
        name: 'groupRules',
        params: {
          id: scope.row.roleid
        }
      });
    },
  },
  watch: {

  },
};
</script>
